import './accessories-slider.scss';

import { SliderSwitcher } from '../../services/slider-switch';
import { CookieHandler } from '../../utilities/js/cookie-handler';
import Swiper, { Lazy, Navigation, Manipulation } from 'swiper';

class AccessoriesSlider {
    constructor (el, options) {
        this.$module = el;
        this.slider = null;
        this.$switcher = null;
        this.slidesRemoved = false;
        this.slidesReady = false;
        this.newData = false;
        this.newDataReady = false;
        this.loader = document.createElement('span');
        this.loader.classList.add('loading');
        this.summaryHandler = null;
        this.actionHandler = null;
        this.cookieHandler = CookieHandler();
        this.translations = window.translations;

        if (typeof window.summaryHandler !== 'undefined') {
            this.summaryHandler = window.summaryHandler;
        }
    }

    initialize () {
        this.createSlider();

        // clear accessoriers cookies
        this.cookieHandler.deleteCookie('armaturen-id');
        this.cookieHandler.deleteCookie('spuelen-id');
    }

    loading ($sliderContainer, status) {
        if (status === 'show') {
            $sliderContainer.appendChild(this.loader);
            const $loadingWrapperShow = $sliderContainer.querySelector('.loading');
            if ($loadingWrapperShow) {
                $loadingWrapperShow.classList.add('loading--show');
            }
        }

        if (status === 'hide') {
            const $loaderHide = $sliderContainer.querySelector('.loading');
            if ($loaderHide) {
                $loaderHide.classList.remove('loading--show');
            }
            setTimeout(() => {
                const $loader = $sliderContainer.querySelector('.loading');
                if ($loader) {
                    $loader.parentNode.removeChild($loader);
                }
            }, 600);
        }
    }

    removeSlides () {
        const $sliderContainer = this.$module.querySelector('.accessories-slider__container');

        $sliderContainer.classList.add('accessories-slider__container--hide');
        $sliderContainer.style.height = $sliderContainer.clientHeight + 'px';

        this.loading($sliderContainer, 'show');
        setTimeout(() => {
            for (let count = 0; count < this.slider.slides.length; count++) {
                this.slider.removeSlide(count);

                if (count === (this.slider.slides.length - 1)) {
                    this.slidesRemoved = true;
                }
            }
        }, 600);
    }

    appendSlides (data) {
        let waitForReady = '';
        const $sliderContainer = this.$module.querySelector('.accessories-slider__container');
        const imageData = data.imageData;

        if (imageData) {
            for (let count = 0; count < imageData.length; count++) {
                if (imageData[count]) {
                    const image = imageData[count].image[0];
                    let imageSrc = '';

                    if (image !== null && typeof image !== 'undefined') {
                        imageSrc = image.desktop;
                    }

                    const price = imageData[count].price ? 'data-price="' + imageData[count].price + '"' : '';

                    this.slider.appendSlide(
                        '<div class="accessories-slider__item swiper-slide" data-accessories-id="' + imageData[count].id + '"><div class="accessories-teaser">' +
                        '<figure class="accessories-teaser__image">' +
                        '<img data-src="' + imageSrc + '" class="swiper-lazy" alt="' + imageData[count].brand + '" /></figure>' +
                        '<div class="accessories-teaser__copy">' +
                        '<p class="accessories-teaser__brand-name">' + imageData[count].brand + '</p>' +
                        '<p class="accessories-teaser__name">' + imageData[count].description + '</p>' +
                        '</div>' +
                        '<ul class="accessories-teaser__actions">' +
                        '<li class="accessories-teaser__actions__item">' +
                        '<a role="button" data-href="/inspiration/ideenbuch/produkt-merken/zubehoer/' + imageData[count].id + '/" class="accessories-teaser__action--store action action--favorite" data-action="' + this.translations.remove_favorite + '" rel="nofollow" data-action-type="favorite"><i>' + this.translations.save_favorite + '</i></a>' +
                        '</li>' +
                        '<li class="accessories-teaser__actions__item">' +
                        '<a data-js="select" class="accessories-teaser__action--select action action--add" rel="nofollow" ' + price + '><i>' + this.translations.choose + '</i></a>' + // eslint-disable-line
                        '</li></ul></div></div>');
                }

                if (count === (imageData.length - 1)) {
                    // last slide containing link to overfiew
                    this.slider.appendSlide('<div class="accessories-slider__item swiper-slide">' +
                        '<div class="accessories-slider__overview-item">' +
                        '<figure class="accessories-slider__overview"></figure>' +
                        '<a href="' + data.overviewLink + '" rel="nofollow" class="accessories-slider__overview-label">' + data.overviewLabel + '</a></div></div>');

                    this.slidesReady = true;
                }
            }
        }

        setTimeout(() => {
            this.slider.slideTo(0, 0);
        }, 50);

        waitForReady = setInterval(() => {
            if (this.slidesReady) {
                this.loading($sliderContainer, 'hide');
                setTimeout(() => {
                    $sliderContainer.classList.remove('accessories-slider__container--hide');
                    $sliderContainer.style.height = '';
                    this.slider.lazy.load();
                }, 600);
                clearInterval(waitForReady);
                this.slidesReady = false;
            }
        });
    }

    generate () {
        const $sliderContainer = this.$module.querySelector('.accessories-slider__container');
        let waitForReady = '';

        this.newData = '';
        if ($sliderContainer.querySelectorAll('.swiper-slide').length > 0) {
            this.removeSlides();
        }

        waitForReady = setInterval(() => {
            if (this.slidesRemoved) {
                if (this.newDataReady) {
                    if (this.newData !== false) {
                        this.appendSlides(this.newData);
                        this.bindSlideEvents();
                        this.slidesRemoved = false;
                        this.newDataReady = false;
                        this.newData = false;
                        this.setActiveSlide();
                        window.initContent(this.$module.querySelector('.accessories-slider__container'));
                    } else {
                        this.errorHandling();
                    }
                    clearInterval(waitForReady);
                }
            }
        }, 100);
    }

    createSlider () {
        this.slider = new Swiper(this.$module.querySelector('.accessories-slider__container'), {
            modules: [Lazy, Navigation, Manipulation],
            slidesPerView: 'auto',
            centeredSlides: true,
            speed: 800,
            resistance: true,
            resistanceRatio: 0,
            preloadImages: true,
            watchSlidesProgress: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 3
            },
            navigation: {
                nextEl: this.$module.querySelector('.accessories-slider__next'),
                prevEl: this.$module.querySelector('.accessories-slider__prev')
            },
            observer: true,
            breakpoints: {
                1023: {
                    slidesPerView: 3
                }
            },
            on: {
                init: function (slider) {
                    if (slider.slides.length <= 3) {
                        slider.lazy.load();
                    }
                }
            }
        });

        this.events();
    }

    events () {
        this.$switcher = this.$module.querySelector('[data-slider-switch]');
        if (this.$switcher) {
            this.$switcher.obj = new SliderSwitcher(this.$switcher);

            this.$switcher.addEventListener('switched', () => {
                this.generate();
            });

            // change slider slides and move slider back to view, when json is loaded
            this.$switcher.addEventListener('dataReady', () => {
                this.newDataReady = true;
                this.newData = this.$switcher.obj.receivedData;
            });
        }

        // bind event on slides
        this.bindSlideEvents();
    }

    bindSlideEvents () {
        const addClickListener = ($element, $allSelects) => {
            $element.addEventListener('click', (e) => {
                e.preventDefault();

                // get teaser of select box
                let $teaser = $element;

                while ($teaser !== document.body) {
                    $teaser = $teaser.parentNode;
                    if ($teaser.classList.contains('accessories-teaser')) {
                        break;
                    }
                }

                this.handleSummary($teaser);
                this.handleSelectActiveState($element, $allSelects);
                this.updatePrice($element);
                this.setAccessorieCookie($teaser);
            });
        };

        // loop over all slides to add event on them
        const $selects = this.$module.querySelectorAll('[data-js="select"]');
        for (let i = 0; i < $selects.length; i++) {
            const $select = $selects[i];
            addClickListener($select, $selects);
        }
    }

    handleSelectActiveState = ($clickedSelect, $allSelects) => {
        for (let i = 0; i < $allSelects.length; i++) {
            const $curSelect = $allSelects[i];
            if ($curSelect === $clickedSelect) {
                if ($clickedSelect.classList.contains('is--active')) {
                    $curSelect.classList.remove('is--active');
                } else {
                    $curSelect.classList.add('is--active');
                }
            } else {
                $curSelect.classList.remove('is--active');
            }
        }
    };

    handleSummary ($teaser) {
        if (this.summaryHandler !== null) {
            const text = $teaser.querySelector('.accessories-teaser__name').textContent;
            let target = this.$module.querySelector('.slider-switch__link.slider-switch__link--active');

            if (target) {
                // get the slider type from the slide switcher attribute
                target = target.getAttribute('data-switch-item');
            } else {
                // get slider type from module data attr
                target = this.$module.getAttribute('data-accessories-slider-name');
            }
            this.summaryHandler.changeContent(target, text);
        }
    }

    getActiveSlider () {
        let activeSlider = '';

        if (this.$switcher === null) {
            activeSlider = this.$module.getAttribute('data-accessories-slider-name');
        } else {
            activeSlider = this.$switcher.querySelector('.slider-switch__link--active').getAttribute('data-switch-item');
        }

        return activeSlider;
    }

    setAccessorieCookie ($teaser) {
        const activeSlider = this.getActiveSlider();
        const id = $teaser.parentNode.getAttribute('data-accessories-id');

        this.cookieHandler.setCookie(activeSlider + '-id', id);
    }

    setActiveSlide () {
        const activeSlider = this.getActiveSlider();
        const slideId = this.cookieHandler.getCookie(activeSlider + '-id');

        if (slideId !== '') {
            const $activeSlide = this.$module.querySelector('[data-accessories-id="' + slideId + '"] [data-js="select"]');
            $activeSlide.classList.add('is--active');
        }
    }

    updatePrice ($selectButton) {
        const price = $selectButton.getAttribute('data-price');
        let product = null;
        const activeSliderSwitch = this.$module.querySelector('.slider-switch__link.slider-switch__link--active');

        if (activeSliderSwitch) {
            product = activeSliderSwitch.getAttribute('data-switch-item');
        }

        if (price !== null && product !== null) {
            if ($selectButton.classList.contains('is--active')) {
                this.summaryHandler.addPrice(product, price);
            } else {
                this.summaryHandler.removePrice(product);
            }
        }
    }
}

export { AccessoriesSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$accessoriesSlider = $context.querySelectorAll('[data-accessories-slider]');
        for (let i = 0; i < $$accessoriesSlider.length; i++) {
            const $accessoriesSlider = new AccessoriesSlider($$accessoriesSlider[i]);
            $accessoriesSlider.initialize();
        }
    }
});
